import { debounce } from "../utils/utils";

document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelectorAll('.populate-hero-nav').length === 0 || document.getElementById('populateHeroNav') === null) {
      const populateHeroNavElement = document.getElementById('populateHeroNav');
      if (populateHeroNavElement !== null) { 
          populateHeroNavElement.remove();
      }
      return;
  }
  
  if (document.querySelectorAll('.hero-nav-item').length === 0) return;
  
  const populateHeroNav = {
      init: () => {
          populateHeroNav.populateDesktopHeroNav();
          window.addEventListener('scroll', debounce(populateHeroNav.stickDesktopHeroNav, 50));
          window.addEventListener("orientationchange", populateHeroNav.stickDesktopHeroNav);
      },
      
      populateDesktopHeroNav: () => {
          let _html = '<div class="container"><ul class="landing-hero-nav my-1 my-lg-3">';
          
          document.querySelectorAll('.hero-nav-item').forEach(function(item) {
              _html += '<li><a href="#' + item.id.replace(/\./g, "").replace(/\?/g,"") + 
                  '" class="landing-hero-nav-link nav-link">' + 
                  item.getAttribute("data-originalid").replace(/-/g, " ") + '</a></li>';
          });
          
          _html += '</ul></div>';
          
          const populateHeroNavElement = document.getElementById('populateHeroNav');
          populateHeroNavElement.insertAdjacentHTML('beforeend', _html);
          
          document.body.setAttribute("data-spy", "scroll");
          document.body.setAttribute("data-target", "#populateHeroNav");
          document.body.setAttribute("data-offset", "230");
      },
      
      stickDesktopHeroNav: () => {
          const populateHeroNavElement = document.getElementById('populateHeroNav');
          const siteHeader = document.querySelector('.site-header');
          
          if (window.scrollY >= 150) {
              populateHeroNavElement.classList.add("stick-to-top");
              populateHeroNavElement.style.top = `${siteHeader.offsetHeight}px`;
          } else {
              populateHeroNavElement.classList.remove("stick-to-top");
              populateHeroNavElement.removeAttribute("style");
          }
      }
  };
  
  populateHeroNav.init();
});